import { useSuggestionsShallowSelector } from 'components/WorkspaceEditor/SuggestionStore'
import { useShallowSelector } from 'components/WorkspaceEditor/Workspace2Store'
import { useCallback } from 'react'
import { useTrackChangeCards } from '../useTrackChangeCards'

/**
 * Hook to reset the active tab and clear tree data.
 *
 * @returns {(tabIndex?: number) => void} - A function to reset the tab.
 */
export const useTabReset = (): ((tabIndex?: number) => void) => {
    const {
        setActiveTab,
        setIsTreeLoading,
        setContentItemViewNodes,
        setArticlesLoading,
        setTreeData,
    } = useShallowSelector((state) => ({
        setActiveTab: state.actions.setActiveTab,
        setIsTreeLoading: state.actions.setIsTreeLoading,
        setContentItemViewNodes: state.actions.setContentItemViewNodes,
        setArticlesLoading: state.actions.setArticlesLoading,
        setTreeData: state.actions.setTreeData,
    }))
    const {
        setIsSuggestionsDataUpdated,
        setIsLoadingCards,
    } = useSuggestionsShallowSelector((state) => ({
        setIsSuggestionsDataUpdated: state.setIsSuggestionsDataUpdated,
        setIsLoadingCards: state.setIsLoadingCards,
    }))
    const { isNotDefaultSuggestionCardFilter } = useTrackChangeCards()

    const resetTab = useCallback(
        (tabIndex?: number) => {
            if (tabIndex !== undefined) {
                setActiveTab(tabIndex + 1)
                setTreeData([])
                setIsSuggestionsDataUpdated(false)
                setIsTreeLoading(true)
                setContentItemViewNodes([])
                setArticlesLoading([])

                if (!isNotDefaultSuggestionCardFilter) {
                    setIsLoadingCards(true)
                }
            }
        },
        [
            setActiveTab,
            setTreeData,
            setIsSuggestionsDataUpdated,
            setIsTreeLoading,
            setContentItemViewNodes,
            setArticlesLoading,
            setIsLoadingCards,
            isNotDefaultSuggestionCardFilter,
        ]
    )

    return resetTab
}
